export enum KeyCode {
  // expand as needed
  Esc = 'Escape',
  Enter = 'Enter',
  Space = ' ',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
}
